import { Node, mergeAttributes } from "@tiptap/core";

export const Iframe = Node.create({
	name: "iframe",

	group: "block",

	draggable: true,

	addAttributes() {
		return {
			src: {
				default: null,
			},
			title: {
				default: null,
			},
			width: {
				default: 560,
			},
			height: {
				default: 315,
			},
			frameborder: {
				default: "0",
			},
			allow: {
				default:
					"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
			},
			allowfullscreen: {
				default: true,
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: "iframe[src]",
			},
		];
	},

	renderHTML({ HTMLAttributes }) {
		return ["iframe", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
	},

	addCommands() {
		return {
			setIframe:
				(options) =>
				({ commands }) => {
					return commands.insertContent({
						type: this.name,
						attrs: options,
					});
				},
		};
	},
});
